
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hot-yoga",
      function () {
        return require("private-next-pages/hot-yoga.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/hot-yoga"])
      });
    }
  